import { Grid2, Typography } from "@mui/material"
import Styles from "./Web.module.css"
import pic from "../../../ui-utils/latestPics/PlatformApi.svg"
import en from "../../../i18n/English/Api/home.json";
import hi from "../../../i18n/Hindi/Api/home.json";
import kn from "../../../i18n/Kannada/Api/home.json";
import ma from "../../../i18n/Marathi/Api/home.json";
import gu from "../../../i18n/Gujarati/Api/home.json";
import { useLanguage } from "../../../Context/LangContext";
export default function WebApi() {
const { language } = useLanguage();
  const translations = { en, hi, kn,gu,ma };
  const t = translations[language];
    return (
        <>
        <Grid2 className={Styles.outerCard}>
         <Grid2 className={Styles.innerCard}>
            <Grid2>

                        <div className={Styles.headingContainer}>
                                          <div className={Styles.gradientBackground}></div>
                            <h1 className={Styles.firstQue} style={{ fontWeight: 600 }}>
                                          {t.questions[0].question}
                                          </h1>
                                        </div>
                                        <br></br>
                        <span className={Styles.subTxt}>
                            {/* As a developer you can use a XTS APis to create powerful solutions for variety of purposes, including integrating your trading application for order execution and access of real-time market prices and information's. To have an access of an API you need to create an App concept that bind you to type of API you wanted to access and provide a API key credential that need to be passed in your each API request */}

                            {t.questions[0].answer}

                        </span>

                        <h1 className={Styles.secondQue}>
                            {/* What is API key? */}
                            {t.questions[1].question}
                        </h1>
                        <span className={Styles.subTxt1}>
                            {/* You will be generating these keys and tokens that you pass along with your API requests with a XTS trading developer app. Each XTS app will be able to generate its own API key and APi secret key that you will use to make requests on behalf of the app, as well as an access tokens and access token secret that you will use to make requests. To have an access of an API you need to create an App concept that bind you to type of API you wanted to access and provide a API key credential that need to be passed in your each API request */}
                            {t.questions[1].answer}

                        </span>
            </Grid2>

                <img src={pic} alt="AlgoTradingLogo" className={Styles.pic} />

            </Grid2>

        </Grid2>
        </>
    )
}